import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PaymentFailedDialogComponent } from '../payment-failed-dialog/payment-failed-dialog.component';

@Component({
  selector: 'app-payment-error',
  // Sin plantilla: solo redirige y abre el diálogo
  template: ''
})
export class PaymentErrorComponent implements OnInit {

  private static readonly EVENT_KEY = 'redsys_pending_event_slug';

  constructor(private dialog: MatDialog, private router: Router) {}

  ngOnInit(): void {
    // Limpiar el id de pedido pendiente para que un pago fallido no afecte a una compra posterior
    localStorage.removeItem('redsys_pending_order_id');

    // El evento que se estaba comprando, guardado antes de ir a Redsys. Solo
    // está si se vuelve al mismo dominio y la compra era de un único evento.
    const eventSlug = localStorage.getItem(PaymentErrorComponent.EVENT_KEY);
    localStorage.removeItem(PaymentErrorComponent.EVENT_KEY);

    // Igual que en el pago correcto: redirigir "por debajo" y mostrar el diálogo encima
    this.router.navigate(eventSlug ? ['/event', eventSlug] : ['/']);
    this.dialog.open(PaymentFailedDialogComponent, {
      panelClass: 'info-dialog',
      data: { eventSlug }
    });
  }
}
